import { callApi } from '@local_modules/generic/fetch.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'

export async function showJournalsWithNoLines (accountingOrganisationId) {
  const url = '/api/data-review/journals-with-no-lines/:accountingOrganisationId'
  const apiResponse = await callApi(url, {
    accountingOrganisationId
  })
  console.log('apiResponse', apiResponse)

  console.log('infoOnJournalsWithNoLines', apiResponse)
  if (!apiResponse) {
    setElementHtml('analysisJournalsNoLines', 'No journals with no lines')
  } else {
    setElementHtml('analysisJournalsNoLines', `${apiResponse.length} journals with no lines`)
  }
}
